import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { PrimaryLink } from "components/Links";
import Icon, { ICON_SIZE, ICON_TYPE } from "components/Icon";
import { colors } from "style";
import { useLinks, usePdfDownload } from "hooks";

/**
 * ApplicantPdfDownloadLink
 *
 * @param {Object} applicant
 */
const ApplicantPdfDownloadLink = ({ applicant }) => {
  const links = useLinks();
  const { downloadPdf } = usePdfDownload();

  const handleDownload = async (e) => {
    e.preventDefault();
    downloadPdf(links.applicant_pdf_download(applicant.uuid));
  };

  return (
    <PrimaryLink to={links.applicant_pdf_download(applicant.uuid)} onClick={handleDownload} rel="noopener noreferrer">
      <FormattedMessage id="Missions.Applicants.ApplicantPdfDownloadLink.Link" />
      <Icon type={ICON_TYPE.arrowDown} size={ICON_SIZE.large} color={colors.purpleRainBase} />
    </PrimaryLink>
  );
};

ApplicantPdfDownloadLink.propTypes = {
  applicant: PropTypes.object.isRequired,
};

export default ApplicantPdfDownloadLink;
